// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_content_delivery_bucket": "rules-engine-ui-20191021124808-hostingbucket-qa",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "https://d3miq9vgert9ul.cloudfront.net"
};


export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js